import axios from "axios";
import apis from "../../utils/constant/appConfig";
const BASE_URL = apis.BASE_URL;
const VIDEO_SEGMENT_URL = apis.VIDEO_SEGMENT_URL;
export const getGhostUsersList = async (token, page = 1) => {
  const url = `${BASE_URL}/api/all/ghost_user/?page=${page}`;
  let config = {
    url: url,
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const getGhostSelectedList = async (token, id) => {
  const url = `${BASE_URL}/api/all/ghost_user/?type=selected&webinar_id=${id}`;
  let config = {
    url: url,
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const getAllghostuserapi = async (token, page = 1) => {
  const url = `${BASE_URL}/api/all/ghost_user/?type=all`;
  let config = {
    url: url,
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const getNormalUserList = async (token, page = 1) => {
  const url = `${BASE_URL}/api/user_list/?page=${page}`;
  let config = {
    url: url,
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const getSearchData = async (
  token,
  id,
  searchValue,
  filter,
  selectedOption,
  page
) => {
  let data = {
    search: searchValue,
    webinar_id: id,
  };

  let config = {
    method: "POST",
    maxBodyLength: Infinity,
    url: `${BASE_URL}/api/webinar/search/?page=${page}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: data,
  };

  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);

        console.log(json.data.total_pages_in_search, "json.data");
      })
      .catch((err) => {
        console.error("Error in API request:", err);
        reject(err);
      });
  });
};

export const getSearchNormalUsersData = async (token, searchVal, page) => {
  const url = `${BASE_URL}/api/user_search/?page=${page}&search=${searchVal}`;

  let config = {
    url: url,
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSearchGhostUser = async (token, searchVal, page) => {
  const url = `${BASE_URL}/api/all/ghost_user/search?search=${searchVal}`;
  let config = {
    url: url,
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getFilterData = async (token, id, attendValue, filter, page) => {
  let data;

  if (attendValue === "YES") {
    data = {
      webinar_id: id,
      filter: attendValue,
    };
  } else if (attendValue === "NO") {
    data = {
      webinar_id: id,
      filter: attendValue,
    };
  } else if (
    attendValue === "0-25" ||
    attendValue === "25-50" ||
    attendValue === "50-75" ||
    attendValue === "75-100"
  ) {
    let dataSplit = attendValue.split("-");
    data = {
      webinar_id: Number(id),
      filter: {
        percentage: { min: Number(dataSplit[0]), max: Number(dataSplit[1]) },
      },
    };
  } else {
    data = {
      webinar_id: Number(id),
      filter: {
        tag: attendValue,
      },
    };
  }

  let config = {
    method: "POST",
    maxBodyLength: Infinity,
    url: `${BASE_URL}/0/api/webinar/search/?page=${page}`,

    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: data,
  };

  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const updateWebinar = async (token, data) => {
  const url = `${BASE_URL}/api/webinar/update/`;
  let config = {
    url: url,
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
    data: data,
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const createWebinar = async (token, data) => {
  const url = `${BASE_URL}/api/webinar/create/`;
  let config = {
    url: url,
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: data,
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          alert("Your Session is Expired. Please log in");
          localStorage.clear();
          window.location.href = "/login"; 
        }
      });
  });
};

export const uploadVideoFile = async (token, data, onUploadProgress) => {
  const url = `${BASE_URL}/api/webinar/video/upload/`;
  let config = {
    url: url,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
    data: data,
    onUploadProgress,
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * Chunked / resumable video upload.
 *
 * Cloudflare's Free plan caps a single HTTP request body at 100 MB, so any
 * single-shot multipart upload bigger than that gets killed at the edge with
 * a 413. To work around that limit *entirely from the frontend*, we slice the
 * file into many small chunks (5 MB by default) and POST each one to the
 * backend's chunked-upload endpoint. The backend then concatenates them into
 * the real video file. There is no per-file size limit anymore – uploads of
 * any size (1 GB, 10 GB, …) work as long as the user's connection holds.
 *
 * @param {string}   token             JWT access token
 * @param {File}     file              The browser File object the user picked
 * @param {function} onUploadProgress  Called with axios-shaped {loaded,total}
 * @param {object}   [opts]            { chunkSize, signal }
 * @returns {Promise<object>}          { video_id, name, video, ... }
 */
export const uploadVideoFileChunked = async (
  token,
  file,
  onUploadProgress,
  opts = {}
) => {
  // 5 MB default – well under Cloudflare's 100 MB cap and small enough to
  // retry quickly if a single chunk fails.
  const chunkSize = opts.chunkSize || 5 * 1024 * 1024;
  const signal = opts.signal;

  const totalSize = file.size;
  const totalChunks = Math.max(1, Math.ceil(totalSize / chunkSize));

  const authHeaders = {
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  };

  // 1) Open an upload session.
  const initFd = new FormData();
  initFd.append("filename", file.name);
  initFd.append("total_chunks", String(totalChunks));
  initFd.append("total_size", String(totalSize));

  const initResp = await axios({
    url: `${BASE_URL}/api/webinar/video/chunked/init/`,
    method: "POST",
    headers: { ...authHeaders, "Content-Type": "multipart/form-data" },
    data: initFd,
    signal,
  });

  const uploadId = initResp.data && initResp.data.upload_id;
  if (!uploadId) {
    throw new Error(
      (initResp.data && initResp.data.message) ||
        "Could not initialise chunked upload"
    );
  }

  // 2) Send every chunk sequentially, reporting cumulative progress.
  let bytesSent = 0;
  for (let i = 0; i < totalChunks; i += 1) {
    const start = i * chunkSize;
    const end = Math.min(start + chunkSize, totalSize);
    const blob = file.slice(start, end);
    const thisChunkSize = end - start;

    const fd = new FormData();
    fd.append("upload_id", uploadId);
    fd.append("chunk_index", String(i));
    // Give the part a stable filename so DRF's MultiPartParser is happy.
    fd.append("chunk", blob, `${file.name}.part${i}`);

    // eslint-disable-next-line no-await-in-loop
    await axios({
      url: `${BASE_URL}/api/webinar/video/chunked/upload/`,
      method: "POST",
      headers: { ...authHeaders, "Content-Type": "multipart/form-data" },
      data: fd,
      signal,
      onUploadProgress: (evt) => {
        if (typeof onUploadProgress !== "function") return;
        // Report progress against the *whole* file, not just this chunk.
        const loadedThisChunk = evt && evt.loaded ? evt.loaded : 0;
        onUploadProgress({
          loaded: Math.min(totalSize, bytesSent + loadedThisChunk),
          total: totalSize,
        });
      },
    });

    bytesSent += thisChunkSize;
    if (typeof onUploadProgress === "function") {
      // Snap to the exact byte count after each successful chunk.
      onUploadProgress({ loaded: bytesSent, total: totalSize });
    }
  }

  // 3) Tell the server we're done; it stitches the file together.
  const completeFd = new FormData();
  completeFd.append("upload_id", uploadId);

  const completeResp = await axios({
    url: `${BASE_URL}/api/webinar/video/chunked/complete/`,
    method: "POST",
    headers: { ...authHeaders, "Content-Type": "multipart/form-data" },
    data: completeFd,
    signal,
  });

  return completeResp.data;
};

/**
 * Cancel a half-finished chunked upload (cleans up server-side temp files).
 * Useful if you wire an "abort" button into the UI.
 */
export const abortChunkedUpload = async (token, uploadId) => {
  const fd = new FormData();
  fd.append("upload_id", uploadId);
  return axios({
    url: `${BASE_URL}/api/webinar/video/chunked/abort/`,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
    data: fd,
  }).then((r) => r.data);
};

export const getUploadVideoList = async (token) => {
  const url = `${BASE_URL}/api/webinar/video/list/`;
  let config = {
    url: url,
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const guestUserAttendees = async (data) => {
  const url = `${BASE_URL}/webinar/guest/attendees/`;
  let config = {
    url: url,
    method: "POST",
    headers: {
      Accept: "application/json",
    },
    data: data,
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


export const changePassword = async (token, data) => {
  const url = `${BASE_URL}/api/change-password/`;
  let config = {
    url: url,
    method: "PUT",
    headers: {
      Accept: "application/json",
      "content-type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
    data: data,
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


export const profileUpdate = async (token, data) => {
  const url = `${BASE_URL}/api/profile/update/`;
  let config = {
    url: url,
    method: "PUT",
    headers: {
      Accept: "application/json",
      "content-type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
    data: data,
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


export const getuserDeta = async (token) => {
  const url = `${BASE_URL}/api/user/data`;
  let config = {
    url: url,
    method: "GET",
    headers: {
      Accept: "application/json",
      "content-type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const chatReport = async (token, id) => {
  const url = `${BASE_URL}/api/chatbot/list/?webinar_id=${id}`;
  let config = {
    url: url,
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const webAnalytics = async (token, id, page = 1) => {
  const url = `${BASE_URL}/webinar/analytics/registration_data?page=${page}&webinar_id=${id}`;
  let config = {
    url: url,
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const webRegistrantsExcel = async (token, id, page = 1) => {
  const url = `${BASE_URL}/webinar/analytics/registration_data?webinar_id=${id}&all_registration_data=ture`;
  let config = {
    url: url,
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const webAnalyticsSession = async (token, id, page = 1) => {
  const url = `${BASE_URL}/webinar/analytics/attendee_data?page=${page}&webinar_id=${id}`;
  let config = {
    url: url,
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
        console.log("configconfigconfig", json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getSessionExcel = async (token, id, page = 1) => {
  const url = `${BASE_URL}/webinar/analytics/attendee_data?webinar_id=${id}&all_session_data=ture`;
  let config = {
    url: url,
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const logOutUser = async (token, data) => {
  const url = `${BASE_URL}/logout`;
  let config = {
    url: url,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
    data: data,
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
// user Login

export const loginUser = async (data) => {
  const url = `${BASE_URL}/api/login`;
  let config = {
    url: url,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
    data: data,
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const UserSignUp = async (data) => {
  const url = `${BASE_URL}/api/user/register/`;
  let config = {
    url: url,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
    data: data,
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const handleAddQuestions = async (token, data) => {
  const url = `${BASE_URL}/add/ghost_user/question`;
  let config = {
    url: url,
    method: "POST",
    headers: {
      Accept: "application/json",
      "content-type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
    data: data,
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const handleAddAnswer = async (token, data) => {
  const url = `${BASE_URL}/add/ghost_user/answer`;
  let config = {
    url: url,
    method: "POST",
    headers: {
      Accept: "application/json",
      "content-type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
    data: data,
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const deleteAnswerList = async (token, id) => {
  const url = `${BASE_URL}/api/ghost/answer_delete?answer_id=${id}`;
  let config = {
    url: url,
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "content-type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const deleteQuestionsAnswerList = async (token, id) => {
  const url = `${BASE_URL}/api/ghost/question_delete?question_id=${id}`;
  let config = {
    url: url,
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "content-type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


export const getQuesAndAnsList = async (token, id) => {
  const url = `${BASE_URL}/api/ghost_user/question_answer?webinar_id=${id}`;
  let config = {
    url: url,
    method: "GET",
    headers: {
      Accept: "application/json",
      "content-type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const videoSegments = async (data) => {
  const url = `${VIDEO_SEGMENT_URL}/api/director/segss`;
  let config = {
    url: url,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
    data: data,
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getVideoHlsPath = async (id) => {
  const url = `${BASE_URL}/api/webinar/live_webinar_details/${id}`;
  let config = {
    url: url,
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getDirectoryVideoList = async (token) => {
  const url = `${BASE_URL}/api/directory/video`;
  let config = {
    url: url,
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const videoDeleteFile = async (token, id, type, folder_name) => {
  const url = `${BASE_URL}/api/video/delete/?id=${id}&type=${type}&folder_name=${folder_name}`;
  let config = {
    url: url,
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const webinarList = async (token, id) => {
  const url = `${BASE_URL}/api/webinar/list/?type=${id}`;
  let config = {
    url: url,
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          alert("Your Session is Expired. Please log in");
          localStorage.clear();     
          window.location.href = "/login";
        }
      });
  });
};

export const deleteWebinars = async (token, id) => {
  const url = `${BASE_URL}/api/webinar/delete/?webinar_id=${id}`;
  let config = {
    url: url,
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "content-type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const sendEmailRecoverPassword = async (data) => {
  const url = `${BASE_URL}/send-reset-password-email/`;
  let config = {
    url: url,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
    data: data,
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const forgetPasswordByEmail = async (userId, userToken, data) => {
  const url = `${BASE_URL}/reset-password/${userId}/${userToken}`;
  let config = {
    url: url,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
    data: data,
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const webinarUpdateData = async (token, id) => {
  const url = `${BASE_URL}/api/webinar/detail/?webinar_id=${id}`;
  let config = {
    url: url,
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const updateDummyUser = async (token, data, id) => {
  const url = `${BASE_URL}/api/add/ghost_user?id=${id}`;
  let config = {
    url: url,
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
    data: data,
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const updateNormalUser = async (token, data, id) => {
  const url = `${BASE_URL}/api/normaluser/update/${id}`;
  let config = {
    url: url,
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
    data: data,
  };
  console.log(data, "ssssssssssssssssssssssssss", config);
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const creteDummyUser = async (token, data) => {
  const url = `${BASE_URL}/api/add/ghost_user`;
  let config = {
    url: url,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
    data: data,
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * Bulk-upload ghost users via an Excel (.xlsx/.xls/.csv) or plain-text (.txt)
 * file. The backend (BulkAddGhostUser) auto-detects the format from the file
 * extension, but we also send `file_type` explicitly so the parser is forced
 * even when the upload is renamed.
 *
 * @param {string} token       JWT access token
 * @param {File}   file        File picked by the user
 * @param {"excel"|"text"|"csv"} fileType  parser hint sent to the backend
 */
export const bulkUploadGhostUsers = async (token, file, fileType) => {
  const url = `${BASE_URL}/api/add/ghost_user/bulk_upload/`;
  const formData = new FormData();
  formData.append("file", file);
  if (fileType) {
    formData.append("file_type", fileType);
  }
  const config = {
    url: url,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
    data: formData,
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// ---------------------------------------------------------------------------
// Media library + S3 integration
//
// The new "Media" tab in the dashboard is powered by these endpoints. They
// live in webinar/media_views.py and webinar/s3_storage.py on the backend.
// Each admin user configures their own AWS S3 bucket – uploads + processed
// videos can then be transferred between the local server and the user's
// bucket, played from either side (with automatic fallback), or removed
// from one or both locations.
// ---------------------------------------------------------------------------

/** Build the standard JSON+JWT axios headers used by every media endpoint. */
const _mediaHeaders = (token) => ({
  Accept: "application/json",
  "Content-Type": "application/json",
  Authorization: `Bearer ${token}`,
});

/** Read the user's currently saved S3 configuration (without the secret). */
export const getS3Config = async (token) => {
  const { data } = await axios({
    url: `${BASE_URL}/api/s3/config/`,
    method: "GET",
    headers: _mediaHeaders(token),
  });
  return data;
};

/**
 * Create or update the active S3 configuration for the current user.
 * Pass `secret_access_key` only when the user actually retypes it – sending
 * an empty string will preserve the previously stored secret on the server.
 */
export const saveS3Config = async (token, payload) => {
  const { data } = await axios({
    url: `${BASE_URL}/api/s3/config/`,
    method: "POST",
    headers: _mediaHeaders(token),
    data: payload,
  });
  return data;
};

/** Delete the user's S3 credentials entirely. */
export const deleteS3Config = async (token) => {
  const { data } = await axios({
    url: `${BASE_URL}/api/s3/config/`,
    method: "DELETE",
    headers: _mediaHeaders(token),
  });
  return data;
};

/**
 * Round-trip the saved credentials against AWS to make sure they actually
 * reach the bucket (the backend just calls HeadBucket).
 */
export const testS3Config = async (token) => {
  const { data } = await axios({
    url: `${BASE_URL}/api/s3/config/test/`,
    method: "POST",
    headers: _mediaHeaders(token),
  });
  return data;
};

/**
 * Unified listing of every uploaded + directory video that belongs to the
 * current admin, plus details about where each one lives (server / S3 /
 * both) and whether ffmpeg processing has been run.
 */
export const getMediaLibrary = async (token) => {
  const { data } = await axios({
    url: `${BASE_URL}/api/media/library/`,
    method: "GET",
    headers: _mediaHeaders(token),
  });
  return data;
};

/**
 * Move a single media item between server and S3.
 *
 * @param {string} token
 * @param {{ id: number, type: "uploade"|"directory", direction: "to_s3"|"from_s3" }} payload
 */
export const transferMedia = async (token, payload) => {
  const { data } = await axios({
    url: `${BASE_URL}/api/media/transfer/`,
    method: "POST",
    headers: _mediaHeaders(token),
    data: payload,
  });
  return data;
};

/**
 * Delete a media item from the server, S3, or both. If both copies are
 * removed the row is also soft-deleted server-side.
 *
 * @param {string} token
 * @param {{ id: number, type: "uploade"|"directory", target: "server"|"s3"|"both" }} payload
 */
export const removeMedia = async (token, payload) => {
  const { data } = await axios({
    url: `${BASE_URL}/api/media/remove/`,
    method: "POST",
    headers: _mediaHeaders(token),
    data: payload,
  });
  return data;
};

/**
 * Ask the backend for the best playback URL for a given media item.
 * The backend returns the preferred source first and a fallback URL for the
 * other location, so the player can swap automatically if one side fails.
 *
 * @param {string} token
 * @param {{ id: number, type: "uploade"|"directory", prefer?: "server"|"s3" }} params
 */
export const getMediaPlaybackUrl = async (token, params) => {
  const { id, type } = params || {};
  const prefer = (params && params.prefer) || "server";
  const { data } = await axios({
    url: `${BASE_URL}/api/media/playback/?id=${encodeURIComponent(id)}&type=${encodeURIComponent(type)}&prefer=${encodeURIComponent(prefer)}`,
    method: "GET",
    headers: _mediaHeaders(token),
  });
  return data;
};


